/**
 * NAT 정책 store
 * @since 2018-08-03
 * @author kdydesign.kim
 */
// utils
import {
  SecutiryPolicyApiPrefix as poApiPrefix,
  SecutiryPolicyApiPrefix as objApiPrefix,
  CommonApiPrefix as cmnApiPrefix
} from 'utils'
// lodash custom move utils
import move from 'lodash-move'
import {pcDownloadFile} from '~/utils/files'
import { pickAddressData, pickServiceData } from '~/utils/policyUtils'
// NAT 정책 순번(seq) 업데이트
const updateRuleSeq = (state) => {
  let seq = 1
  state.natRulesList = _.map(state.natRulesList, (o) => {
    if (!o.is_group) {
      o.seq = seq
      seq++
    }
    return o
  })
}
// NAT 정책 - 변경전 주소(출발지/목적지) 객체 데이터
const initBeforeNatRulesAddrData = () => {
  return [{addr_obj_id: 0, excpt: 0, name: 'Any', addr_obj_type: 0}]
}
// NAT 정책 - 변경 전 서비스 객체 데이터
const initBeforeNatRulesServiceData = () => {
  return [{srv_obj_id: 0, name: 'Any', srv_obj_type: 0}]
}
// NAT 정책 - 변경후 주소(출발지/목적지) 객체 데이터
const initAfterNatRulesAddrData = () => {
  return [{addr_obj_id: 0, excpt: 0, name: 'Org', addr_obj_type: 0}]
}
// NAT 정책 - 변경 후 서비스 객체 데이터
const initAfterNatRulesServiceData = () => {
  return [{srv_obj_id: 0, name: 'Org', srv_obj_type: 0}]
}
// NAT 정책 데이터
const initNatRulesData = () => {
  return {
    nat_grp_id: 0,
    up_down: 1,
    name: void 0,
    desc: void 0,
    use: 1,
    ifc: [],
    basic_nat_mode: 2,
    adv_nat_mode: void 0,
    serv_sched: 0,
    serv_check: 0,
    src: initBeforeNatRulesAddrData(),
    dst: initBeforeNatRulesAddrData(),
    srv: initBeforeNatRulesServiceData(),
    act_src: initAfterNatRulesAddrData(),
    act_dst: initAfterNatRulesAddrData(),
    act_srv: initAfterNatRulesServiceData()
  }
}
export const state = () => ({
  multipleSelect: false,
  natRulesList: [],
  multiLineInterfaceConfData: [],
  natRulesData: initNatRulesData(),
  selectedAddObjectData: void 0,
  selectedPolicyData: void 0,
  copyNatRulesData: void 0,
  natApplyInterface: [],
  natMultiLineApplyInterface: []
})
export const mutations = {
  // NAT 정책 목록 조회
  getNatRulesList (state, data) {
    state.natRulesList = _.map(data, (rule) => {
      if (rule.adv_nat_mode === 13) rule.act_src[0] = _.assign(rule.act_src[0], { name: 'DYNAMIC_IP' })
      if (rule.adv_nat_mode === 14) rule.act_src[0] = _.assign(rule.act_src[0], { name: 'MULTILINE' })
      if (rule.adv_nat_mode === 22) rule.dst[0] = _.assign(rule.dst[0], { name: 'DYNAMIC_IP' })
      return rule
    })
  },
  // NAT 정책 선택 초기화, 복사된 정책 데이터 초기화
  resetSelectedPolicyRules (state) {
    state.selectedPolicyData = void 0
    state.copyNatRulesData = void 0
  },
  // NAT 정책 store 초기화
  resetNatRulesStore (state) {
    state.natRulesList = []
    state.natRulesData = initNatRulesData()
    state.selectedPolicyData = void 0
    state.selectedAddObjectData = void 0
    state.copyNatRulesData = void 0
  },
  // NAT 정책 선택
  selectedPolicyRules (state, data) {
    state.selectedPolicyData = data
    state.copyNatRulesData = _.map(state.copyNatRulesData, (o) => {
      return _.assign(o, {
        nat_grp_id: data.nat_grp_id,
        pre_rule_id: data.nat_rule_id,
        up_down: 1
      })
    })
  },
  // 방화벽 정책 이동 후 seq 업데이트 및 기준 정책 seq 업데이트
  updatePreRuleSeq (state) {
    updateRuleSeq(state)
  },
  // NAT 정책 추가
  saveNatRules (state, data) {
    const selectData = state.selectedPolicyData
    const result = data
    const natRulesList = state.natRulesList
    if (result.adv_nat_mode === 13) result.act_src[0] = _.assign(result.act_src[0], { name: 'DYNAMIC_IP' })
    if (result.adv_nat_mode === 14) result.act_src[0] = _.assign(result.act_src[0], { name: 'MULTILINE' })
    if (result.adv_nat_mode === 22) result.dst[0] = _.assign(result.dst[0], { name: 'DYNAMIC_IP' })
    if (selectData && selectData.nat_grp_id === data.nat_grp_id) {
      const index = _.findIndex(state.natRulesList, {nat_rule_id: selectData.nat_rule_id})
      natRulesList.splice(index, 0, result)
    } else {
      const index = _.findIndex(state.natRulesList, {nat_grp_id: data.nat_grp_id})
      natRulesList.splice(index + 1, 0, result)
    }
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // NAT 정책 삭제
  deleteNatRules (state, data) {
    const natRulesList = state.natRulesList
    const itemIndex = _.findIndex(natRulesList, {nat_rule_id: data})
    natRulesList.splice(itemIndex, 1)
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // 객체 별 추가
  addNatObjectData (state, {item, objectType, advNatMode, basicMode, type}) {
    const advNatModeTemp = advNatMode || state.natRulesData.adv_nat_mode,
      basicModeTemp = basicMode || state.natRulesData.basic_nat_mode
    let objectId = void 0
    if (['src', 'act_src', 'dst', 'act_dst'].includes(objectType)) objectId = state.natRulesData[objectType][0].addr_obj_id
    if (['srv', 'act_srv'].includes(objectType)) objectId = state.natRulesData[objectType][0].srv_obj_id
    if (objectId === 0 && state.natRulesData[objectType].length === 1) state.natRulesData[objectType].splice(0, 1)
    if ([21, 22].includes(advNatModeTemp)) {
      if (objectType === 'act_dst') {
        if (state.selectedAddObjectData && state.selectedAddObjectData.addr_obj_id === 0 && type !== 'manual') {
          const itemIndex = state.selectedAddObjectData.itemIndex
          const index = _.findIndex(state.natRulesData.act_dst, {itemIndex})
          state.natRulesData.act_dst.splice(index, 1, item)
        } else {
          const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
          state.natRulesData[objectType].push(cloneItem)
        }
        if (state.natRulesData.act_dst.length !== state.natRulesData.act_srv.length) { // 목적지 객체 수에 따라 서비스 객체 추가
          const initDstData = _.head(initAfterNatRulesServiceData())
          state.natRulesData.act_srv.push(initDstData)
        }
      } else if (objectType === 'act_srv') {
        if (state.selectedAddObjectData && state.selectedAddObjectData.srv_obj_id === 0) {
          const itemIndex = state.selectedAddObjectData.itemIndex
          const index = _.findIndex(state.natRulesData.act_srv, {itemIndex})
          state.natRulesData.act_srv.splice(index, 1, item)
        } else {
          const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
          state.natRulesData[objectType].push(cloneItem)
        }
        if (state.natRulesData.act_srv.length !== state.natRulesData.act_dst.length) { // 서비스 객체 수에 따라 목적지 추가
          const initSrvData = _.head(initAfterNatRulesAddrData())
          state.natRulesData.act_dst.push(initSrvData)
        }
      } else {
        const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
        state.natRulesData[objectType].push(cloneItem)
      }
    } else {
      const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
      state.natRulesData[objectType].push(cloneItem)
    }
    // 1:N 변환
    if (basicModeTemp === 20 && objectType === 'act_dst') {
      const initDstData = _.head(initAfterNatRulesServiceData())
      state.natRulesData.act_srv.push(initDstData)
    }
    state.selectedAddObjectData = void 0
  },
  // NAT 정책 팝업 창에서 객체 별 일괄 추가
  addNatMultipleObjectData (state, {items, objectType, advNatMode}) {
    let objectId = void 0
    if (objectType === 'srv' || objectType === 'act_srv') {
      objectId = state.natRulesData[objectType][0].srv_obj_id
    } else if (objectType === 'src' || objectType === 'dst' || objectType === 'act_src' || objectType === 'act_dst') {
      objectId = state.natRulesData[objectType][0].addr_obj_id
    }
    if (objectId === 0) state.natRulesData[objectType].splice(0, 1)
    _.forEach(items, (item) => {
      if (advNatMode === 21 || advNatMode === 22) {
        if (objectType === 'act_dst') {
          if (state.selectedAddObjectData && state.selectedAddObjectData.addr_obj_id === 0) {
            const itemIndex = state.selectedAddObjectData.itemIndex
            const index = _.findIndex(state.natRulesData.act_dst, {itemIndex})
            state.natRulesData.act_dst.splice(index, 1, item)
          } else {
            const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
            state.natRulesData[objectType].push(cloneItem)
          }
          // 목적지 객체 수에 따라 서비스 객체 추가
          if (state.natRulesData.act_dst.length !== state.natRulesData.act_srv.length) {
            const initDstData = _.head(initAfterNatRulesServiceData())
            state.natRulesData.act_srv.push(initDstData)
          }
        } else if (objectType === 'act_srv') {
          if (state.selectedAddObjectData && state.selectedAddObjectData.srv_obj_id === 0) {
            const itemIndex = state.selectedAddObjectData.itemIndex
            const index = _.findIndex(state.natRulesData.act_srv, {itemIndex})
            state.natRulesData.act_srv.splice(index, 1, item)
          } else {
            const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
            state.natRulesData[objectType].push(cloneItem)
          }
          if (state.natRulesData.act_srv.length !== state.natRulesData.act_dst.length) { // 서비스 객체 수에 따라 목적지 추가
            const initSrvData = _.head(initAfterNatRulesAddrData())
            state.natRulesData.act_dst.push(initSrvData)
          }
        } else {
          const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
          state.natRulesData[objectType].push(cloneItem)
        }
      } else {
        const cloneItem = _.cloneDeep(_.assign(item, {excpt: 0}))
        state.natRulesData[objectType].push(cloneItem)
      }
    })
    state.selectedAddObjectData = void 0
  },
  // NAT 정책 조회
  getNatRules (state, data) {
    if (data.dst[0].addr_obj_type === 0 && data.adv_nat_mode === 22) data.dst[0] = _.assign(data.dst[0], { name: 'DYNAMIC_IP' })
    if (data.act_src[0].addr_obj_type === 0) {
      if (data.adv_nat_mode === 13) {
        data.act_src[0] = _.assign(data.act_src[0], { name: 'DYNAMIC_IP' })
      }
      if (data.adv_nat_mode === 14) {
        data.act_src[0] = _.assign(data.act_src[0], { name: 'MULTILINE' })
      }
    }

    if (data.ifc.length > 0) {
      if (data.adv_nat_mode === 14) {
        state.multiLineInterfaceConfData = _.cloneDeep(data).ifc
        data = _.assign(_.cloneDeep(data), {
          ifc: _.map(data.ifc, (ifc) => { return ifc.ifc_name })
        })
      } else {
        data = _.assign(data, {
          ifc: _.map(data.ifc, (ifc) => { return ifc.ifc_name })
        })
      }
    }

    state.natRulesData = data
  },

  // 추가된 객체 별 삭제
  deleteNatObjectData (state, {item, objectType, advNatMode}) {
    const natObjectDataList = state.natRulesData[objectType]
    const itemIndex = _.indexOf(natObjectDataList, item)
    // 1:N 확장 변환, 1:N 동적 변환
    if (advNatMode === 21 || advNatMode === 22) {
      if (objectType === 'act_dst') {
        natObjectDataList.splice(itemIndex, 1)
        if (state.natRulesData.act_srv.length !== 1 && state.natRulesData.act_srv[0].srv_obj_id !== 0) {
          state.natRulesData.act_srv.splice(itemIndex, 1)
        } else if (state.natRulesData.act_srv.length !== 1 && state.natRulesData.act_srv[0].srv_obj_id === 0) {
          state.natRulesData.act_srv.splice(itemIndex, 1)
        }
      } else if (objectType === 'act_srv') {
        natObjectDataList.splice(itemIndex, 1)
        if (state.natRulesData.act_dst.length !== 1 && state.natRulesData.act_dst[0].addr_obj_id !== 0) {
          state.natRulesData.act_dst.splice(itemIndex, 1)
        } else if (state.natRulesData.act_dst.length !== 1 && state.natRulesData.act_dst[0].addr_obj_id === 0) {
          state.natRulesData.act_dst.splice(itemIndex, 1)
        }
      } else { natObjectDataList.splice(itemIndex, 1) }
    } else { natObjectDataList.splice(itemIndex, 1) }
    if (natObjectDataList.length === 0) {
      if (objectType === 'src' || objectType === 'dst') state.natRulesData[objectType] = initBeforeNatRulesAddrData()
      if (objectType === 'act_src' || objectType === 'act_dst') state.natRulesData[objectType] = initAfterNatRulesAddrData()
      if (objectType === 'srv') state.natRulesData[objectType] = initBeforeNatRulesServiceData()
      if (objectType === 'act_srv') state.natRulesData[objectType] = initAfterNatRulesServiceData()
    }
    state.selectedAddObjectData = void 0
  },
  // NAT 정책 수정
  updateNatRules (state, data) {
    const orgData = _.find(state.natRulesList, {nat_rule_id: data.nat_rule_id})
    const result = data
    if (result.adv_nat_mode === 13) result.act_src[0] = _.assign(result.act_src[0], { name: 'DYNAMIC_IP' })
    if (result.adv_nat_mode === 14) result.act_src[0] = _.assign(result.act_src[0], { name: 'MULTILINE' })
    if (result.adv_nat_mode === 22) result.dst[0] = _.assign(result.dst[0], { name: 'DYNAMIC_IP' })
    if (orgData.nat_grp_id !== result.nat_grp_id) {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      state.natRulesList.splice(selectIndex, 1)
      const groupIndex = _.findIndex(state.natRulesList, {nat_grp_id: result.nat_grp_id})
      state.natRulesList.splice(groupIndex + 1, 0, result)
    } else {
      state.natRulesList = _.map(state.natRulesList, (o) => {
        if (o.nat_rule_id === result.nat_rule_id) o = result
        return o
      })
    }
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // 추가된 객체의 예외 객체 설정
  changeExceptObject (state, {except, type}) {
    const selectedDataId = state.selectedAddObjectData.addr_obj_id
    _.map(state.natRulesData[type], (o) => {
      if (o.addr_obj_id === selectedDataId) o.excpt = except
    })
  },
  // NAT 정책 데이터 초기화
  resetNatRulesData (state) {
    state.natRulesData = initNatRulesData()
  },
  // NAT 정책 이동 위치 변경
  updateNatPolicyPos (state, {pos, result, moveNum, isGroup, preRule, isOpen}) {
    const natRulesList = state.natRulesList
    let targetSeq = 0
    let moveSeq = 0
    if (pos === 'up') {
      if (isGroup && isOpen) {
        const removeIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
        const addIndex = _.findIndex(state.natRulesList, {nat_grp_id: preRule.nat_grp_id, is_group: true})
        state.natRulesList.splice(removeIndex, 1)
        state.natRulesList.splice(addIndex, 0, result)
      } else if (isGroup && !isOpen) {
        const removeIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
        const groupIndex = _.findIndex(state.natRulesList, {nat_grp_id: result.nat_grp_id})
        state.natRulesList.splice(removeIndex, 1)
        state.natRulesList.splice(groupIndex + 1, 0, result)
      } else {
        targetSeq = state.selectedPolicyData.itemIndex
        moveSeq = state.selectedPolicyData.itemIndex - 1
        state.natRulesList = move(natRulesList, targetSeq, moveSeq)
      }
    }
    if (pos === 'down') {
      if (isGroup) {
        const removeIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
        const addIndex = _.findIndex(state.natRulesList, {nat_grp_id: preRule.nat_grp_id, is_group: true})
        state.natRulesList.splice(removeIndex, 1)
        state.natRulesList.splice(addIndex, 0, result)
      } else {
        targetSeq = state.selectedPolicyData.itemIndex
        moveSeq = state.selectedPolicyData.itemIndex + 1
        state.natRulesList = move(natRulesList, targetSeq, moveSeq)
      }
    }
    if (pos === 'top') {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      const firstRule = _.filter(state.natRulesList, (rule) => {
        if (!_.has(rule, 'is_group')) return rule
      })[0]
      const firstIndex = _.findIndex(state.natRulesList, {nat_rule_id: firstRule.nat_rule_id})
      state.natRulesList.splice(selectIndex, 1)
      state.natRulesList.splice(firstIndex, 0, result)
    }
    if (pos === 'bottom') {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      const lastRuleIndex = _.findLastIndex(state.natRulesList, (rule) => {
        if (!_.has(rule, 'is_group')) return rule
      })
      state.natRulesList.splice(selectIndex, 1)
      state.natRulesList.splice(lastRuleIndex, 0, result)
    }
    if (pos === 'manual') {
      const maxSeqLen = _.filter(natRulesList, rule => !rule.is_group).length
      if (Number(moveNum) > maxSeqLen) {
        const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
        const lastRuleIndex = _.findLastIndex(state.natRulesList, rule => !rule.is_group)
        state.natRulesList.splice(selectIndex, 1)
        state.natRulesList.splice(lastRuleIndex, 0, result)
      } else {
        const removeIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
        state.natRulesList.splice(removeIndex, 1)
        const addIndex = _.findIndex(state.natRulesList, (o) => {
          if (!o.is_group && o.seq === Number(moveNum)) return true
        })
        state.natRulesList.splice(addIndex, 0, result)
      }
    }
    if (pos === 'dragManual') {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      state.natRulesList.splice(selectIndex, 1)
      state.natRulesList.splice(Number(moveNum), 0, result)
    }
    if (pos === 'groupTop') {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      state.natRulesList.splice(selectIndex, 1)
      const groupIndex = _.findIndex(state.natRulesList, {nat_grp_id: result.nat_grp_id})
      state.natRulesList.splice(groupIndex + 1, 0, result)
    }
    if (pos === 'groupBottom') {
      const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: result.nat_rule_id})
      state.natRulesList.splice(selectIndex, 1)
      const groupLastData = _.findLast(state.natRulesList, {nat_grp_id: result.nat_grp_id})
      const groupIndex = _.findIndex(state.natRulesList, groupLastData)
      state.natRulesList.splice(groupIndex + 1, 0, result)
    }
  },
  // NAT 정책 일괄 이동 위치 변경
  updateBatchPolicyPos (state, {result, pos, moveNum}) {
    const natRulesList = state.natRulesList
    if (pos === 'manual') {
      const maxSeqLen = _.filter(natRulesList, rule => !rule.is_group).length
      if (Number(moveNum) > maxSeqLen) {
        _.forEach(result, (item) => {
          const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: item.nat_rule_id})
          const lastRuleIndex = _.findLastIndex(state.natRulesList, rule => !rule.is_group)
          state.natRulesList.splice(selectIndex, 1)
          state.natRulesList.splice(lastRuleIndex, 0, item)
        })
      } else {
        _.forEach(result, (item) => {
          const removeIndex = _.findIndex(state.natRulesList, {nat_rule_id: item.nat_rule_id})
          state.natRulesList.splice(removeIndex, 1)
          state.natRulesList.splice(item.seq, 0, item)
        })
      }
    }
    if (pos === 'groupTop') {
      _.forEach(result, (item) => {
        const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: item.nat_rule_id})
        state.natRulesList.splice(selectIndex, 1)
      })
      _.forEach(result, (item, i) => {
        const groupIndex = _.findIndex(state.natRulesList, {nat_grp_id: item.nat_grp_id})
        state.natRulesList.splice(groupIndex + (i + 1), 0, item)
      })
    }
    if (pos === 'groupBottom') {
      _.forEach(result, (item) => {
        const selectIndex = _.findIndex(state.natRulesList, {nat_rule_id: item.nat_rule_id})
        state.natRulesList.splice(selectIndex, 1)
      })
      _.forEach(result, (item) => {
        const groupLastData = _.findLast(state.natRulesList, {nat_grp_id: item.nat_grp_id})
        const groupIndex = _.findIndex(state.natRulesList, groupLastData)
        state.natRulesList.splice(groupIndex + 1, 0, item)
      })
    }
  },
  // 추가된 객체 선택
  selectedAddObject (state, data) {
    state.selectedAddObjectData = data
  },
  // 객체 별 추가된 객체 데이터 목록 초기화
  resetNatRulesAddObjectData (state, {selectedObj, advNatMode}) {
    if (selectedObj === 'src' || selectedObj === 'dst') {
      state.natRulesData[selectedObj] = initBeforeNatRulesAddrData()
    }
    if (selectedObj === 'act_src' || selectedObj === 'act_dst') {
      state.natRulesData[selectedObj] = initAfterNatRulesAddrData()
      if ([21, 22].includes(advNatMode) && selectedObj === 'act_dst') {
        const len = state.natRulesData.act_srv.length
        state.natRulesData.act_srv.splice(1, len - 1)
      }
    }
    if (selectedObj === 'srv') state.natRulesData[selectedObj] = initBeforeNatRulesServiceData()
    if (selectedObj === 'act_srv') state.natRulesData[selectedObj] = initAfterNatRulesServiceData()
    state.selectedAddObjectData = void 0
  },
  // 객체 별 추가된 객체 데이터 모두 초기화
  resetAllAddData (state) {
    state.natRulesData.ifc = []
    state.natRulesData.src = initBeforeNatRulesAddrData()
    state.natRulesData.dst = initBeforeNatRulesAddrData()
    state.natRulesData.srv = initBeforeNatRulesServiceData()
    state.natRulesData.act_src = initAfterNatRulesAddrData()
    state.natRulesData.act_dst = initAfterNatRulesAddrData()
    state.natRulesData.act_srv = initAfterNatRulesServiceData()
  },
  // 기본 변환 방식 변경
  basicChangeType (state, type) {
    if (type === void 0) state.natRulesData.adv_nat_mode = 3
    else state.natRulesData.adv_nat_mode = void 0
    // 옵션 활성화
    if (type === 20) state.natRulesData.serv_sched = 1
    else state.natRulesData.serv_sched = 0
  },

  // 고급 변환 방식 변경
  adChangeType (state, type) {
    if (state.natRulesData.act_src[0].addr_obj_id === 0) {
      let name = void 0
      if (type === 13) name = 'DYNAMIC_IP'
      else if (type === 14) name = 'MULTILINE'
      else name = 'Org'
      state.natRulesData.act_src = _.map(state.natRulesData.act_src, (o) => {
        o.name = name
        return o
      })
    }
    // 1:N 동적 변환
    if (state.natRulesData.dst[0].addr_obj_id === 0) {
      let name = void 0
      if (type === 22) name = 'DYNAMIC_IP'
      else name = 'Any'
      state.natRulesData.dst = _.map(state.natRulesData.dst, (o) => {
        o.name = name
        return o
      })
    }
    // 옵션 활성화
    // 1:N 확장변환, 1:N 동적변환
    if ([21, 22].includes(type)) state.natRulesData.serv_sched = 1
    else state.natRulesData.serv_sched = 0
  },

  // NAT 정책 복사
  copyNatPolicy (state) {
    let selectData = []
    state.copyNatRulesData = []
    if (state.multipleSelect) selectData = state.selectedPolicyData
    else selectData.push(state.selectedPolicyData)
    _.forEach(selectData, (data) => {
      state.copyNatRulesData.push({
        nat_grp_id: data.nat_grp_id,
        pre_rule_id: data.nat_rule_id,
        up_down: 1,
        name: void 0,
        desc: data.desc,
        use: data.use,
        ifc: data.ifc,
        basic_nat_mode: data.basic_nat_mode,
        adv_nat_mode: data.adv_nat_mode,
        serv_sched: data.serv_sched,
        serv_check: data.serv_check,
        src: pickAddressData(data.src),
        dst: pickAddressData(data.dst),
        srv: pickServiceData(data.srv),
        act_src: pickAddressData(data.act_src),
        act_dst: pickAddressData(data.act_dst),
        act_srv: pickServiceData(data.act_srv)
      })
    })
  },
  // NAT 정책 붙여넣기
  pasteNatPolicy (state, data) {
    const selectRule = state.selectedPolicyData,
      addIndex = _.findIndex(state.natRulesList, {nat_rule_id: selectRule.nat_rule_id})
    if (data.adv_nat_mode === 13) data.act_src[0] = _.assign(data.act_src[0], { name: 'DYNAMIC_IP' })
    if (data.adv_nat_mode === 14) data.act_src[0] = _.assign(data.act_src[0], { name: 'MULTILINE' })
    if (data.adv_nat_mode === 22) data.dst[0] = _.assign(data.dst[0], { name: 'DYNAMIC_IP' })
    state.natRulesList.splice(addIndex, 0, data)
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // 기본 그룹 지정
  setNatGroup (state, data) {
    state.natRulesData.nat_grp_id = data
  },
  // 다중 선택 여부 설정
  setMultipleSelect (state, data) {
    state.multipleSelect = data
  },
  // NAT 정책 일괄 삭제
  deleteBatchNatRules (state, data) {
    const natRulesList = state.natRulesList
    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(natRulesList, {nat_rule_id: o.nat_rule_id})
      natRulesList.splice(itemIndex, 1)
    })
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // NAT 정책 적용 인터페이스 목록 조회
  getApplyInterface (state, data) {
    state.natApplyInterface = data
  },
  // NAT 정책 적용 인터페이스(멀티라인) 목록 조회
  getMultiLineApplyInterface (state, data) {
    state.natMultiLineApplyInterface = data
  },
  // 인터페이스 데이터 설정
  setInterfaceConfig (state, {role, rowData}) {
    const multiInterfaceId = rowData.id
    state.natRulesData.ifc = _.map(state.natRulesData.ifc, (ifc) => {
      let param = void 0
      if (role) param = { role }
      if (multiInterfaceId === ifc.id) ifc = _.assign(ifc, param)
      return ifc
    })
  },
  // 멀티라인 N:M Port Pool 상세 설정
  setMultiLineInterfaceConfData (state) {
    state.multiLineInterfaceConfData = _.map(state.natRulesData.ifc, (ifc) => {
      return { ifc_name: ifc, role: 0, prio: 0 }
    })
  },
  // 멀티라인 N:M Port Pool 상세 설정 - standby우선 순위 초기화
  resetStandbyOrder (state) {
    state.multiLineInterfaceConfData = _.map(state.multiLineInterfaceConfData, (conf) => {
      return _.assign(conf, { prio: 0 })
    })
  },
  // 가중치 초기화
  resetWeightedData (state) {
    state.natRulesData.act_dst = _.map(state.natRulesData.act_dst, (actDst) => {
      return _.assign(actDst, { weight: 1 })
    })
  }
}
export const actions = {
  // 객체 별 추가
  addNatObjectData ({commit}, {item, objectType, advNatMode, basicMode, type}) {
    commit('addNatObjectData', {item, objectType, advNatMode, basicMode, type})
  },
  // NAT 정책 팝업 창에서 객체 별 일괄 추가
  addNatMultipleObjectData ({commit}, {items, objectType, advNatMode}) {
    commit('addNatMultipleObjectData', {items, objectType, advNatMode})
  },
  // 기본 그룹 지정
  setNatGroup ({state, commit, rootState}) {
    const natGroupList = rootState.securityPolicy.nat.natPolicySettings.natGroupMgmt.natGroupList
    let defaultGroupID = natGroupList[0].nat_grp_id
    if (state.multipleSelect) {
      defaultGroupID = _.findLast(state.selectedPolicyData).nat_grp_id
    } else {
      if (state.selectedPolicyData) {
        defaultGroupID = state.selectedPolicyData.nat_grp_id
      }
    }
    commit('setNatGroup', defaultGroupID)
  },
  // NAT 정책 목록 조회
  async getNatRulesList ({commit, state}, {loadingShow} = true) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/rules`, {loadingShow: loadingShow})
    if (code === 'ok') commit('getNatRulesList', result)
  },
  // NAT 정책 추가
  async saveNatRules ({commit, state, dispatch}) {
    const selectData = state.selectedPolicyData
    let natRulesData = _.assign(_.cloneDeep(state.natRulesData), {
      src: pickAddressData(state.natRulesData.src),
      dst: pickAddressData(state.natRulesData.dst),
      srv: pickServiceData(state.natRulesData.srv),
      act_src: pickAddressData(state.natRulesData.act_src),
      act_dst: pickAddressData(state.natRulesData.act_dst),
      act_srv: pickServiceData(state.natRulesData.act_srv)
    })
    if (selectData && selectData.nat_grp_id === natRulesData.nat_grp_id) {
      natRulesData = _.assign(natRulesData, {
        pre_rule_id: selectData.nat_rule_id,
        up_down: 1,
        nat_grp_id: selectData.nat_grp_id
      })
    }
    if (natRulesData.adv_nat_mode !== void 0) {
      let parseInterface = []
      if (natRulesData.adv_nat_mode === 14) {
        parseInterface = state.multiLineInterfaceConfData
      } else {
        _.forEach(natRulesData.ifc, (ifc) => {
          const paramInterface = { ifc_name: ifc }
          parseInterface.push(paramInterface)
        })
      }
      natRulesData = _.assign(natRulesData, { ifc: parseInterface })
    }
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/nat/rules`, natRulesData)
    if (code === 'ok') {
      commit('saveNatRules', result)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // NAT 정책 붙여넣기
  async pasteNatPolicy ({commit, state, dispatch}) {
    const promises = []
    const copyNatRulesData = state.copyNatRulesData
    for (let i = 0; i < copyNatRulesData.length; i++) {
      promises.push(
        new Promise((resolve) => {
          this.$axios.$post(`${objApiPrefix}/nat/rules`, copyNatRulesData[i])
            .then(({code, result}) => {
              if (code === 'ok') {
                resolve(result)
                commit('pasteNatPolicy', result)
                dispatch('common/common/setIsChanged', true, {root: true})
              }
            })
        })
      )
    }
  },
  // NAT 정책 수정
  async updateNatRules ({commit, state, dispatch}) {
    const natRulesId = state.selectedPolicyData.nat_rule_id
    let natRulesData = _.assign(_.cloneDeep(state.natRulesData), {
      src: pickAddressData(state.natRulesData.src),
      dst: pickAddressData(state.natRulesData.dst),
      srv: pickServiceData(state.natRulesData.srv),
      act_src: pickAddressData(state.natRulesData.act_src),
      act_dst: pickAddressData(state.natRulesData.act_dst),
      act_srv: pickServiceData(state.natRulesData.act_srv)
    })
    if (natRulesData.adv_nat_mode !== void 0) {
      if (natRulesData.adv_nat_mode === 14) {
        natRulesData = _.assign(natRulesData, { ifc: state.multiLineInterfaceConfData })
      } else {
        const parseInterface = []
        _.forEach(natRulesData.ifc, (ifc) => {
          const paramInterface = { ifc_name: ifc }
          parseInterface.push(paramInterface)
        })
        natRulesData = _.assign(natRulesData, { ifc: parseInterface })
      }
    }
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/nat/rules/${natRulesId}`, natRulesData)
    if (code === 'ok') {
      commit('updateNatRules', result)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // NAT 정책 수정 - 사용 여부
  async updateNatPolicyUse ({commit, state, dispatch}, {use, ruleId}) {
    const {code, result} = await this.$axios.$put(`${poApiPrefix}/nat/rules/${ruleId}`, {use})
    if (code === 'ok') {
      commit('updateNatRules', result)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // NAT 정책 조회
  async getNatRules ({commit, state}, {natRuleId}) {
    const natRulesId = natRuleId || state.selectedPolicyData.nat_rule_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/rules/${natRulesId}`)
    if (code === 'ok') commit('getNatRules', result)
  },
  // NAT 정책 삭제
  async deleteNatRules ({commit, state, dispatch}) {
    const natRulesId = state.selectedPolicyData.nat_rule_id
    const {code} = await this.$axios.$delete(`${objApiPrefix}/nat/rules/${natRulesId}`)
    if (code === 'ok') {
      commit('deleteNatRules', natRulesId)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 엑셀 다운로드 (비동기)
  async excelDownload () {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/rules/save`)
    if (code === 'async') return result.id
  },
  // 엑셀 파일 다운로드
  async excelFileDownload ({state}, {taskId}) {
    const {data, fileName} = await this.$axios.$file(`${cmnApiPrefix}/async/tasks/${taskId}/save`, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },
  // NAT 정책 적용
  async policyApply ({commit, dispatch}) {
    await this.$axios.$put(`${objApiPrefix}/command/nat-policies/apply`, void 0, { applyMsg: true })
    dispatch('common/common/setIsChanged', false, {root: true})
    commit('resetSelectedPolicyRules')
  },
  // NAT 정책 취소
  async policyCancel ({commit, dispatch}) {
    await this.$axios.$put(`${objApiPrefix}/command/nat-policies/cancel`, void 0, { cancelMsg: true })
    dispatch('common/common/setIsChanged', false, {root: true})
    commit('resetSelectedPolicyRules')
  },
  // NAT 정책 임시 저장
  async saveNatTempStorage ({state, commit, rootState, dispatch}) {
    const natPolicySetList = rootState.securityPolicy.nat.natPolicySettings.natPolicySet.natPolicySetList
    const usingSetId = _.find(natPolicySetList, {use: 1}).nat_set_id
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/nat/sets/${usingSetId}/tempsave`, void 0, { alertMsg: '임시 저장되었습니다.' })
    if (code === 'ok') {
      commit('securityPolicy/nat/natPolicySettings/natPolicySet/setTempStoragePolicySet', result, {root: true})
      dispatch('common/common/setIsChanged', false, {root: true})
    }
  },
  // NAT 정책 임시 저장 조회
  async getNatTempStorage () {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/sets/tempsave`)
    if (code === 'ok') return result
  },
  // NAT 정책 일괄 삭제
  async deleteBatchNatRules ({commit, dispatch, state}) {
    const params = { items: _.map(state.selectedPolicyData, o => _.pick(o, ['nat_rule_id'])) }
    const {code, result} = await this.$axios.$delete(`${objApiPrefix}/nat/rules`, {data: params})
    if (code === 'ok') {
      commit('deleteBatchNatRules', params.items)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    } else if (code === 'pok' || code === 'nok') return result.errors
  },
  // NAT 정책 적용 인터페이스 목록
  async getApplyInterface ({commit}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/interfaces`)
    if (code === 'ok') commit('getApplyInterface', result)
  },
  // NAT 정책 적용 인터페이스(멀티라인) 목록
  async getMultiLineApplyInterface ({commit}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/multiline/interfaces`)
    if (code === 'ok') commit('getMultiLineApplyInterface', result)
  },
  // NAT 정책 설정 적용
  async natApplyConfig () {
    await this.$axios.$put(`${objApiPrefix}/command/nat-config/apply`, void 0, {successAlert: false})
  }
}
export const getters = {
  // 가중치 데이터
  weightedData (state) {
    if (state.natRulesData.act_dst[0].addr_obj_id === 0) {
      return []
    } else {
      if (_.has(state.natRulesData, 'weight')) {
        state.natRulesData.act_dst = _.map(state.natRulesData.act_dst, (actDst, i) => {
          return _.assign(actDst, { weight: state.natRulesData.weight[i] || 1 })
        })
      } else {
        state.natRulesData.act_dst = _.map(state.natRulesData.act_dst, (actDst) => {
          return _.assign(actDst, { weight: 1 })
        })
      }
      return state.natRulesData.act_dst
    }
  },

  // 적용 인터페이스
  selectTypeApplyInterface (state) {
    const
      natApplyInterface = state.natApplyInterface,
      natMultiLineApplyInterface = state.natMultiLineApplyInterface

    let interfaceList = []

    if (state.natRulesData.adv_nat_mode === 14) {
      interfaceList = _.map(natMultiLineApplyInterface, (inf) => {
        return _.assign(inf, { role: 0, prio: 0 })
      })
    } else { interfaceList = natApplyInterface }
    return _.map(interfaceList, (o) => {
      return { label: o.name, value: o.name }
    })
  }
}
export const strict = false
